<template>
    <div>
        <limitless-page-header :title="'Användare'" :buttons="[{'url':'/users/0','text':'Ny användare', 'icon':'icon-plus-circle2'}]"></limitless-page-header>

        <div class="content">
            <rednax-datatable :url="'/vue/users/table'" :columns="table_columns" :filter="table_filter" @updateFilter="table_filter=$event" @rowclick="rowClick" history>
                <div class="row">
                    <div class="col-lg-3">
                        <input type="text" v-model="table_filter.search" class="form-control">
                    </div>
                    <div class="col-lg-9 text-right">
                        <limitless-button
                            btn-class="btn-light"
                            @click="table_filter.show_suspended = !table_filter.show_suspended"
                            :icon="(table_filter.show_suspended ? 'icon-eye-blocked' : 'icon-eye')"
                        >
                            {{ (table_filter.show_suspended ? 'Dölj' : 'Visa') }} inaktiva användare
                        </limitless-button>
                    </div>
                </div>
            </rednax-datatable>
        </div> <!-- /content -->
    </div>
</template>

<script>
import LimitlessPageHeader from '@components/Limitless/LimitlessPageHeader';
import RednaxDatatable from '@components/RednaxDatatableComponent';
import LimitlessButton from '../components/Limitless/LimitlessButton';

export default {
    name: 'UserList',
    components: {
        LimitlessButton,
        LimitlessPageHeader,
        RednaxDatatable,
    },
    data: () => ({
        table_filter: {
            search: '',
            show_suspended: false,
        },
        table_columns: [
            {
                header: '#',
                data: 'id',
                sortable: true,
                render(row) {
                    if (row.deleted_at) {
                        return '<span style="text-decoration: line-through; color:red;">' + row.id + '</span>';
                    }
                    return row.id;
                },
            },
            {
                header: 'Namn',
                data: 'name',
                sortable: true,
                render(row) {
                    if (row.deleted_at) {
                        return '<span style="text-decoration: line-through; color:red;">' + row.name + '</span>';
                    }
                    return row.name;
                },
            },
            {
                header: 'E-post',
                data: 'email',
                sortable: true,
                render(row) {
                    if (row.deleted_at) {
                        return '<span style="text-decoration: line-through; color:red;">' + row.email + '</span>';
                    }
                    return row.email;
                },
            },
        ],
    }),
    methods: {
        rowClick(row) {
            window.location.href = '/users/' + row.id;
        },
    },
};

</script>
